import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide7Bridge.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide7Bridge(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease }}
        className="text-4xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.headline}
      </motion.h2>
    </div>
  )
}
